module.exports = __webpack_public_path__ + "res/Roboto-CondensedItalic-webfont.eot?80de7bf784c2263b3fe8c08580104df9";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-CondensedItalic-webfont.eot
// module id = 36
// module chunks = 0